import { ZfDialog, ZfDialogContent, ZfDialogFooter, ZfDialogHeader, ZfFormField, ZfInput, ZfSelectOption, ZfTextButton, ZfTypography } from '@zafire/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useClient, useSetClientCurrency } from '../../api';

type Currency = 'CHF' | 'EUR' | 'USD' | 'GBP';

export const ClientCurrencyModal = () => {
    const { t } = useTranslation();
    const { data: client } = useClient();
    const setClientCurrency = useSetClientCurrency();

    const [currency, setCurrency] = useState<Currency>('CHF');

    const onSave = () => setClientCurrency.mutate({ clientId: client!.id, currency });

    return (
        <ZfDialog show={!client?.currency} size="medium" showCloseButton={false} disableLightDismiss={true}>
            <ZfDialogHeader>{t('clientReferenceCurrency')}</ZfDialogHeader>
            <ZfDialogContent>
                <ZfTypography variant="body-medium">{t('clientReferenceCurrencyExplanation')}</ZfTypography>
                <ZfFormField label={t('wealthItemCurrency')} mandatory={true} style={{ marginTop: 'var(--padding-top-sm)' }}>
                    <ZfInput type="select" value={currency} onSelectChange={(e) => setCurrency(e.detail as Currency)}>
                        {['CHF', 'EUR', 'USD', 'GBP'].map((currency) => (
                            <ZfSelectOption key={currency} value={currency} description={currency} />
                        ))}
                    </ZfInput>
                </ZfFormField>
            </ZfDialogContent>
            <ZfDialogFooter>
                <ZfTextButton slot="primary" size="medium" hierarchy="primary" onClick={onSave} disabled={!!client?.id && !currency}>
                    {t('modalSaveButton')}
                </ZfTextButton>
            </ZfDialogFooter>
        </ZfDialog>
    );
};
